import type { Contact } from "@/features/contact/types";
import type { CallActivityPayload } from "./activity";
import type { Message } from "./message";

export const CONVERSATION_STATUS = {
  OPEN: "open",
  CLOSED: "closed",
  SNOOZED: "snoozed",
} as const;

export type ConversationStatus =
  (typeof CONVERSATION_STATUS)[keyof typeof CONVERSATION_STATUS];

export const CONVERSATION_VIEW = {
  ALL: "all",
  FOLLOW_UP: "follow_up",
  MENTIONS: "mentions",
  PARTICIPATING: "participating",
  UNATTENDED: "unattended",
  // Conversations owned solely by the AI: agent active, no human assigned.
  AI: "ai",
} as const;

export type ConversationView =
  (typeof CONVERSATION_VIEW)[keyof typeof CONVERSATION_VIEW];

export const CONVERSATION_STATUS_OPTIONS: {
  value: ConversationStatus;
  label: string;
}[] = [
  { value: CONVERSATION_STATUS.OPEN, label: "Open" },
  { value: CONVERSATION_STATUS.CLOSED, label: "Closed" },
  { value: CONVERSATION_STATUS.SNOOZED, label: "Snoozed" },
];

export type CallActivitySummary = {
  id: string;
  createdAt: string;
  payload: CallActivityPayload;
};

export type Conversation = {
  contact: Contact;
  message?: Message;
  call?: CallActivitySummary;
};

export type UpdateConversationPayload = {
  conversationId: string;
  status: ConversationStatus;
};

export type ConversationStateCount = {
  mine: number;
  unassigned: number;
  // Owned by someone other than you. mine + teammates + unassigned = all.
  teammates: number;
  all: number;
  unreplied: number;
  // Follow-ups needing attention now: due today (through end of day) or overdue.
  dueFollowUp: number;
  // AI-attention quick-filter buckets.
  needsHuman: number;
  knowledgeGap: number;
  draftPending: number;
  questionPending: number;
  approvalPending: number;
  needsYou: number;
};

export type UnreadMentionCount = {
  conversations: number;
  mentions: number;
};
